import { ICart } from '../CartComponent';
import { cartKeyWords } from '../Other/keywords';

export const replaceLocalStorage = (data: ICart) => {
  localStorage.setItem(cartKeyWords.localStorageKey, JSON.stringify(data));
};
